import src from "IMAGE";
export default { src, width: 240, height: 48, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/webp;base64,UklGRkwAAABXRUJQVlA4TD8AAAAvB0AAEM1VICICEeGBABIAAAAAnD8wAADAMNgPPxgAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAIA+GbIH+kjtsnEA"};
